// src/hooks/useEstimateForm.ts
import { useState } from "react";
import { CoverForm, defaultCoverForm } from "../contracts/estimates/types.ts";
import { useEstimateApi } from "./useEstimateApi.ts";
import { defaultProductItem, ProductItem } from "../pages/product_manager/types.ts";

const API_BASE = process.env.REACT_APP_API_BASE;

export default function useProductItemForm(initial: ProductItem = defaultProductItem) {
  // TODO: Need to apply useApi
  const [productItemForm, setProductItemForm] = useState<ProductItem>(initial);
  
  // 목적(checkbox) 값 전용 헬퍼
  const extractKey = (name: string) =>
    name.includes(".") ? name.split(".").pop()! : name;

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const { name, value } = e.target;
    const key = extractKey(name)

    setProductItemForm((prev) => ({ ...prev, [key]: value }));
  };

  const autoGrow = (el: HTMLTextAreaElement) => {
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
  };

  return { 
    productItemForm,
    handleChange,
    autoGrow
  };
}
